import { Routing } from '../Routes';
import { match, useParams } from 'react-router-dom';
import { useApi, Res, fetchResourceMap } from '../../state/api';
import { Main } from '../Main/Main';
import { LoaderPage } from './LoaderPage';
import { ErrorPage } from './ErrorPage';
import { useTranslation } from '../../i18n/i18n';
import { renderTemplate } from '../utils';
import { LinkListingFilter } from '../../components/LinkListingFilter/LinkListingFilter';
import { Helmet } from 'react-helmet-async';

type UrlParams = { brandSlug: string };

export const PrinterModelPage = (): JSX.Element => {
	const { brandSlug } = useParams<UrlParams>();
	const { data: printerBrand, error } = useApi(Res.printerModels, {
		brandSlug,
	});
	const t = useTranslation().tonerGuide;
	const urls = useTranslation().routes;

	if (error) return <ErrorPage />;
	if (!printerBrand) return <LoaderPage />;

	return (
		<Main>
			<Helmet>
				<title>{renderTemplate(t.brandTitle, { brandName: printerBrand.brandName })}</title>
			</Helmet>
			<h1>{printerBrand.brandName}</h1>
			<p>
				{renderTemplate(t.selectYourPrinter, {
					brandName: printerBrand.brandName,
				})}
			</p>
			<LinkListingFilter
				searchLabel={renderTemplate(t.searchLabel, {
					model: printerBrand.brandName,
				})}
				showHr
				isDense
				hideTabs
				links={Object.entries(printerBrand.models).map((model) => ({
					url: `${urls.printer}/${brandSlug}/${model[0]}`,
					name: model[1],
					key: model[1],
				}))}
			/>
		</Main>
	);
};

export const printerModelRouting: Routing<UrlParams> = {
	path(urls) {
		return `${urls.printer}/:brandSlug`;
	},
	component: PrinterModelPage,
	requiresAuth: false,
	preload: async (config, routeMatch: match<UrlParams>, _query: string) => {
		const { brandSlug } = routeMatch.params;
		return fetchResourceMap(config, Res.printerModels, { brandSlug });
	},
};
